import { OverlayType } from '../constants/common'
import IchimokuCloud from './ic'

class IchimokuCloudFull extends IchimokuCloud {
  static type = OverlayType.Icf
  static label = 'Ichimoku Cloud (Full)'
  static renderFull = true
}

export default IchimokuCloudFull
